import { useTranslation } from 'react-i18next';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import { Textarea } from 'aha-components';

export default function ScreeningQuestions() {
  const { t } = useTranslation();
  const { screeningQuestions, updateScreeningQuestionAnswer } =
    useMultiplePricesStore();

  if (!screeningQuestions?.length) return null;

  return (
    <div className="flex flex-col gap-3">
      <div className="justify-start text-[#0D0D0D] text-base font-semibold font-['Inter'] leading-6">
        {t('screening_questions.title', {
          defaultValue: 'Screening questions'
        })}
      </div>
      <div className="flex flex-col gap-3 pr-4">
        {screeningQuestions?.map((question, index) => (
          <div
            className="flex flex-col gap-1.5"
            key={`${question?.question}-${index}`}
          >
            <div className="size- inline-flex justify-start items-start gap-0.5">
              <div className="justify-start text-[#44403C] text-sm font-medium font-['DM_Sans'] leading-5">
                {question?.question}
              </div>
              <div className="justify-start text-[#EC470A] text-sm font-medium font-['DM_Sans'] leading-5">
                *
              </div>
            </div>
            <Textarea
              value={question?.answer ?? ''}
              placeholder={t('screening_questions.input_placeholder', {
                defaultValue: 'Input your answer'
              })}
              onChange={(e) =>
                updateScreeningQuestionAnswer(index, e.target.value)
              }
              autoSize={{ minRows: 1, maxRows: 3 }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
